import { useMutation } from 'react-query';

import { getFinishDateDueToEditStartDateOrDuration as mutationFn } from 'api/endPoints/getFinishDateDueToEditStartDateOrDuration';

export const useMutationGetFinishDateDueToEditStartDateOrDuration = () => {
    return useMutation<
        IGetFinishDateDueToEditStartDateOrDurationResponse,
        QueryError,
        IGetFinishDateDueToEditStartDateOrDurationPayload
    >((params) => mutationFn(params));
};

interface IGetFinishDateDueToEditStartDateOrDurationPayload {
    id: number;
    startDate: number;
    remainingDurationInDays: number;
    isVirtual: boolean;
    taskId: number;
}

interface IGetFinishDateDueToEditStartDateOrDurationResponse {
    endDate: number;
}
